import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ROUTES } from "../utils/constants";
import { logout } from "../redux/authSlice";
import ThemeToggle from "./ThemeToggle";
import styles from "./AdminLayout.module.css";

export default function AdminLayout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const handleLogout = async () => {
    await dispatch(logout()).unwrap();
    navigate(ROUTES.LOGIN, { replace: true });
  };

  const navItems = [
    { path: ROUTES.ADMIN_DASHBOARD, label: "Dashboard", icon: "📊" },
    { path: ROUTES.ADMIN_EMPLOYEES, label: "Employee List", icon: "👥" },
    { path: ROUTES.ADMIN_CREATE_EMPLOYEE, label: "Create Employee", icon: "➕" },
    { path: ROUTES.ADMIN_DCR_REPORTS, label: "DCR Reports", icon: "📈" },
  ];

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <div className={styles.sidebarHeader}>
          <div>
            <h2>Admin Panel</h2>
            <p>{user?.email}</p>
          </div>
          <ThemeToggle className={styles.headerThemeToggle} />
        </div>
        <nav className={styles.nav}>
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `${styles.navLink} ${isActive ? styles.active : ""}`}
            >
              <span className={styles.navIcon}>{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className={styles.sidebarFooter}>
          <button onClick={handleLogout} className={styles.logoutBtn}>
            Logout
          </button>
        </div>
      </aside>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
